module.exports = __webpack_public_path__ + "static/profile-f4a0c66ce17e5c82f8fda58deed16c59.jpg";